module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_20.f99dc0dc.jpeg";